import * as signalR from '@microsoft/signalr'
import { useAuthStore } from '@/shared/state/authstore'

let connection: signalR.HubConnection | null = null

function hubUrl(): string {
  const base = import.meta.env.VITE_API_BASE_URL as string
  const origin = base.replace(/\/api\/?$/, '')
  return `${origin}/hubs/notifications`
}

export function getNotificationsConnection(): signalR.HubConnection {
  if (connection) return connection
  connection = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl(), {
      accessTokenFactory: () => useAuthStore.getState().accessToken ?? '',
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Warning)
    .build()
  return connection
}

export async function startNotificationsConnection(): Promise<void> {
  const conn = getNotificationsConnection()
  if (conn.state === signalR.HubConnectionState.Disconnected) {
    try {
      await conn.start()
    } catch {
      // automatic reconnect handles retry; never throw into React render
    }
  }
}

export async function stopNotificationsConnection(): Promise<void> {
  if (!connection) return
  const conn = connection
  connection = null
  try {
    await conn.stop()
  } catch {
    // ignore
  }
}
